export default __webpack_public_path__ + "static/media/headline.bcc41383.svg";